module.exports = __webpack_public_path__ + "static/img/公众号.db1c3b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/common/公众号.jpg
// module id = VDrb
// module chunks = 1